<div class="container search-bar-cont" [class.results]="isResultsPage">
  <div class="travel-destination-cont">
    <app-search-place-input
      class="searchBarDesktop__departure"
      [icon]="icons.StartPoint"
      [searchType]="searchType"
      [placeType]="departure"
      [place]="departurePlace"
      [samePlaceError]="samePlaceError"
      [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.FROM' | transloco"
      [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_ORIGIN' | transloco"
      [departurePlace]="departurePlace"
      [autoCompletePlaces]="autoCompletePlaces"
      [airports]="airports"
      [eventPath]="eventPath | async"
      [selected]="!selectedArrivalPlace"
      [showError]="isDeparturePlaceEmpty"
      [activateCursor]="!hasArrival"
      (selectPlace)="selectedPlace($event)"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
      (inputChanged)="placeInputChanged.emit($event)"
      (showSearchInput)="showSearchInputDeparture()"
      (removeAutoCompletePlaces)="removeAutoCompletePlaces.emit()"
      (locationNotFoundEvent)="locationNotFoundEvent($event)"
      (popularSelected)="popularSelectedEvent($event)">
    </app-search-place-input>
    <div class="searchBarDesktop__swipe-locations" [class.results]="isResultsPage">
      <app-ds-button-icon
        [buttonSize]="buttonIconSize"
        [icon]="arrowIcon"
        (clickEvent)="swapLocations()">
      </app-ds-button-icon>
    </div>
    <app-search-place-input
      class="searchBarDesktop__arrival"
      [class.results]="isResultsPage"
      [isDisabled]="destination"
      [icon]="icons.Location"
      [searchType]="searchType"
      [placeType]="arrival"
      [place]="arrivalPlace"
      [samePlaceError]="samePlaceError"
      [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
      [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION' | transloco"
      [departurePlace]="departurePlace"
      [autoCompletePlaces]="autoCompletePlaces"
      [airports]="airports"
      [eventPath]="eventPath | async"
      [selected]="selectedArrivalPlace"
      [showError]="isValidArrivalPlace"
      [activateCursor]="activateArrivalCursor"
      (selectPlace)="selectedPlace($event)"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
      (inputChanged)="placeInputChanged.emit($event)"
      (showSearchInput)="showSearchInputArrival()"
      (removeAutoCompletePlaces)="removeAutoCompletePlaces.emit()"
      (locationNotFoundEvent)="locationNotFoundEvent($event)"
      (popularSelected)="popularSelectedEvent($event)">
    </app-search-place-input>
  </div>
  <div class="travel-calendar-cont">
    <a *ngIf="isResultsPage" class="goBackBtnContainer" (click)="goBack()">
      <app-ds-icon
        [icon]="icons.ChevronLeft"
        [size]="16"
        [color]="iconFillColor.Secondary">
      </app-ds-icon>
      <app-ds-typography
        [size]="fontSize.XXXS"
        [color]="fontColor.Secondary"
        [text]="'BACK' | transloco">
      </app-ds-typography>
    </a>
    <div class="travel-calendar-flight-type" *ngIf="isResultsPage">
        <span (click)="toggleFlightOption('FLIGHT_TYPE')">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [tag]="'p'"
            [color]="fontColor.Secondary"
            [text]="'SEARCH_MODULE.FLIGHT_TYPE.' + flightType | transloco">
          </app-ds-typography>
          <app-ds-icon
            [icon]="icons.ChevronDown"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
        </span>
        <span (click)="toggleFlightOption('PASSENGER_ARRANGEMENT')">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [tag]="'p'"
            [color]="fontColor.Secondary"
            [text]="passengerArrangement | passengerInput : searchType">
          </app-ds-typography>
          <app-ds-icon
            [icon]="icons.ChevronDown"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
        </span>
        <span *ngIf="!isBuses" class="flight-class" (click)="toggleFlightOption('FLIGHT_CLASSES')">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [tag]="'p'"
            [color]="fontColor.Secondary"
            [text]="'SEARCH_MODULE.FLIGHT_CLASSES.' + activeFlightClass | transloco">
          </app-ds-typography>
          <app-ds-icon
            [icon]="icons.ChevronDown"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
        </span>

        <div [ngSwitch]="activeOption" class="flight-options-cont {{activeOption | lowercase}}" [class.active]="showDesktopSearchOptions">
          <ng-container *ngSwitchCase="'FLIGHT_TYPE'">
            <ng-container *ngTemplateOutlet="flighTypeOptions"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'PASSENGER_ARRANGEMENT'">
            <ng-container *ngTemplateOutlet="passengerSelection"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'FLIGHT_CLASSES'">
            <ng-container *ngTemplateOutlet="passengerSelection"></ng-container>
          </ng-container>
        </div>
    </div>

    <div class="travel-calendar-input-cont">
      <div class="calendar-search">
        <app-search-bar-calendar
          [isOneWayTrip]="isOneWayTrip"
          [arrivalDate]="arrivalDate"
          [departurePlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
          [returnPlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco"
          [departureDate]="departureDate"
          [show]="showCalendarInput"
          [fieldActivated]="dateCalendarField"
          [flightTypeCalendar]="flightType"
          [searchType]="searchType"
          (emitApplySelection)="applyCalendar($event)"
          (flightType)="flightTypeCalendar($event)">
        </app-search-bar-calendar>
      </div>
      <app-search-bar-input
        [id]="'calendar-departure'"
        [showError]="isEmptyDepartureDate"
        [searchType]="searchType"
        [label]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
        [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
        [value]="departureDate | flightDate: showYear"
        [icon]="icons.Calendar"
        [swapPlaceholder]= true
        (isFocus)="setCalendarField('left')">
      </app-search-bar-input>
      <app-search-bar-input
        [id]="'calendar-arrival'"
        [showError]="isEmptyArrivalDate"
        [searchType]="searchType"
        [label]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco"
        [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco"
        [value]="arrivalDate | flightDate: showYear"
        [icon]="icons.Calendar"
        [disabled]="isOneWayTrip"
        [swapPlaceholder]= true
        (isFocus)="setCalendarField('right')">
      </app-search-bar-input>
      <div class="passengers-input" *ngIf="!isResultsPage">
        <ng-container *ngTemplateOutlet="passengerSelection"></ng-container>
      </div>
      <div class="checkbox" *ngIf="!isBuses" style="display: none;">
        <input [ngModel]="baggageIncluded" (ngModelChange)="baggageIncludedChange($event)" [value]="baggageIncluded" type="checkbox" [id]="'BaggageIncluded'">
        <label [attr.for]="'BaggageIncluded'">
            {{'SEARCH_MODULE.BAGGAGE_INCLUDE' | transloco}}
        </label>
      </div>
      <ng-container *ngIf="showBaggageIncluded">
        <div class="checkbox" *ngIf="!isBuses">
          <input [ngModel]="baggageIncluded" (ngModelChange)="baggageIncludedChange($event)" [value]="baggageIncluded" type="checkbox" [id]="'BaggageIncluded'">
          <label [attr.for]="'BaggageIncluded'">
              {{'SEARCH_MODULE.BAGGAGE_INCLUDE' | transloco}}
          </label>
        </div>
      </ng-container>
    </div>
    <div class="button-container">
      <app-ds-button
        [showIcon]="true"
        [icon]="searchIcon"
        [size]="buttonSize"
        (clickEvent)="searchFlights()">
      </app-ds-button>
    </div>
  </div>
</div>

<ng-template #flighTypeOptions>
  <div class="searchBarDesktop__radio" *ngFor="let type of flightTypes">
    <app-ds-radio-button
      [checked]="isActiveFlightType(type)"
      [title]="{ Label: 'SEARCH_MODULE.FLIGHT_TYPE.' + type | transloco }"
      (radioOnChecked)="flightTypeSelected(type)">
    </app-ds-radio-button>
  </div>
</ng-template>

<ng-template #passengerSelection>
  <app-search-bar-passenger-selection
    [searchType]="searchType"
    [isMobile]="false"
    [activeOption]="activeOption"
    [eventPath]="eventPath | async"
    [passengerArrangement]="passengerArrangement"
    [activeFlightClass]="activeFlightClass"
    (emitArrangement)="emitArrangement.emit($event)"
    (emitApplySelection)="toggleFlightOption()"
    (emitFlightClassSelection)="emitFlightClassSelection.emit($event)">
  </app-search-bar-passenger-selection>
</ng-template>
